import(/* webpackMode: "eager", webpackExports: ["ReduxProvider"] */ "/app/src/store/ReduxProvider.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/styles/global.scss");
